// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/dist/css/ionicons.min.css
// module id = 1029
// module chunks = 0